import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import HeadingLines from '../assets/images/heading-lines.svg' 

function HomeSeniorLivingOptions({data}) {

  if (!data) {
    return null; // Correct return for better handling
  }
  

  return (
    <> 
    <section className="home-senior-living-options">
      <Container>
        <Row>
          <Col md="12">
              <div className="common-header mb-4">
                <img src={HeadingLines} alt="" />
                <h2>{data.title}</h2> 
              </div>
          </Col>
           
          {data.cards.map((card, index) => (
            <Col key={index} sm="12" lg="6" className='mt-4'>
              <div className="home-senior-living-options-box">
                <img className="home-senior-living-options-box-img" src={`${process.env.REACT_APP_PHP_BACKEND_MEDIA_URL}${card.image}`}  alt={card.title} />
                <div className="home-senior-living-options-box-text">
                  <h2>{card.title}</h2>
                  <p>{card.subtitle}</p>
                </div>
              </div>
            </Col>
          ))}

        </Row>        
      </Container>
    </section>
    </>
  )
}
export default HomeSeniorLivingOptions